import { __awaiter, __generator } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
export function getMruConfig(options) {
    return __awaiter(this, void 0, void 0, function () {
        var mruConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, resolveConfig('mruConfig', options)];
                case 1:
                    mruConfig = _a.sent();
                    return [2 /*return*/, mruConfig];
            }
        });
    });
}
//# sourceMappingURL=getMruConfig.js.map